module.exports = __webpack_public_path__ + "static/media/no_eye.ae6dd31c.svg";